// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-app-header-notifications-NotificationCreatedAt-module__root--3Ph7S"};